import { RouteObject } from "react-router-dom";
import RequireAuth from "../../auth/requireAuth";
import { RssFeedContainer } from "./rssFeed/rssFeedContainer";
import { RSSFEED_TYPE } from "./rssFeed/rssFeedUtils";
import { LINK_TYPE, ReferenceContainer } from "./reference/referenceContainer";
import { LookupCategoryDto } from "../../services/dto/account/lookupCategoryDto";
import { LookupDto } from "../../services/dto/account/lookupDto";
import { LookupGroupDto } from "../../services/dto/account/lookupGroupDto";
import { SettingDto } from "../../services/dto/account/settingDto";
import { LookupGroupContainer } from "../lookup/lookupgroup/lookupGroupContainer";
import { LookupTypeContainer } from "../lookup/lookuptype/lookupTypeContainer";
import { LookupValueContainer } from "../lookup/lookupvalue/lookupValueContainer";
import { SettingContainer } from "../setting/settingContainer";
import { CommunityDevelopmentContainer } from "./communityDevelopment/communityDevelopmentContainer";
import { Module } from "../../assets/types";
import { permissions } from "../../assets/configuration/claimSettings";
import { PushNotificationContainer } from "./pushNotification/pushNotificationContainer";
import { AdvertisementContainer } from "./advertisement/advertisementContainer";
import { OrganizationContainer } from "../community/resource/organization/organizationContainer";
import { NonprofitOrganizationContainer } from "../community/nonprofit/organization/organizationContainer";
import { BannerContainer } from "./banner/bannerContainer";

export const HereNowRoutes: RouteObject = {
  path: "herenow",
  children: [
    {
      path: "feeds",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageRssfeeds,
          ]}
        >
          <RssFeedContainer />
        </RequireAuth>
      ),
    },
    {
      path: "newsfeeds",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageNewsfeeds,
          ]}
        >
          <RssFeedContainer rssFeedTypeId={RSSFEED_TYPE.NEWS} />
        </RequireAuth>
      ),
    },
    {
      path: "events",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageEvents,
          ]}
        >
          <RssFeedContainer rssFeedTypeId={RSSFEED_TYPE.EVENTS} />
        </RequireAuth>
      ),
    },
    {
      path: "reference",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageResource,
          ]}
        >
          <ReferenceContainer linkTypeId={LINK_TYPE.REFERENCE_ITEM} />
        </RequireAuth>
      ),
    },
    {
      path: "explore",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageResource,
          ]}
        >
          <ReferenceContainer linkTypeId={LINK_TYPE.EXPLORE_ITEM} />
        </RequireAuth>
      ),
    },
    {
      path: "navmenu",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageQuicklinks,
          ]}
        >
          <ReferenceContainer linkTypeId={LINK_TYPE.NAV_MENU_ITEM} />
        </RequireAuth>
      ),
    },
    {
      path: "sociallink",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageSociallinks,
          ]}
        >
          <ReferenceContainer linkTypeId={LINK_TYPE.SOCIAL_ITEM} />
        </RequireAuth>
      ),
    },
    {
      path: "lookuptype",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageLookup,
          ]}
        >
          <LookupTypeContainer<LookupCategoryDto> moduleType={Module.PopHub} />
        </RequireAuth>
      ),
    },
    {
      path: "lookupgroup",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageLookup,
          ]}
        >
          <LookupGroupContainer<LookupGroupDto> moduleType={Module.PopHub} />
        </RequireAuth>
      ),
    },
    {
      path: "lookupvalue",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageLookup,
          ]}
        >
          <LookupValueContainer<LookupDto> moduleType={Module.PopHub} />
        </RequireAuth>
      ),
    },
    {
      path: "settings",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageLookup,
          ]}
        >
          <SettingContainer<SettingDto> moduleType={Module.PopHub} />
        </RequireAuth>
      ),
    },
    {
      path: "communityresource",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageCommunity,
          ]}
        >
          <OrganizationContainer />
        </RequireAuth>
      ),
    },
    {
      path: "nonprofit",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageCommunity,
          ]}
        >
          <NonprofitOrganizationContainer />
        </RequireAuth>
      ),
    },
    {
      path: "communitydevelopment",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageCommunityDevelopment,
          ]}
        >
          <CommunityDevelopmentContainer />
        </RequireAuth>
      ),
    },
    {
      path: "push-notification",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManagePushNotifications,
          ]}
        >
          <PushNotificationContainer />
        </RequireAuth>
      ),
    },
    {
      path: "banner",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageLookup,
            permissions.ManageQuicklinks,
          ]}
        >
          <BannerContainer />
        </RequireAuth>
      ),
    },
  ],
};
